import React, { useEffect, useState } from "react";
import { NetworkManager } from "../../../Components/NetworkManager";
import { CommonUtil } from "../../../utils/CommonUtil";
import ToastManager from "../../../Components/ToastManager";

const DashboardWidget = ({ widgetSelected, onAddClick, count }: any) => {
  const saasOrgId = CommonUtil.getSaasOrgId();
  const [selectedWidget, setSelectedWidget] = useState<any>(null);
  const [dynamicWidgets, setDynamicWidgets] = useState<any>([]);
  const supportedAddButtons = ["Broker/Carriers"];

  const staticWidgets = [
    // {  label: "Document Comparison", count: 0, image: "../images/compare.svg", InfoText: "Last 30 Days" },
    { label: "Forced Complete", count: count?.forceClosedDocumentCount || 0, image: "../images/Forced-Complete.svg", InfoText: "Last 6 Months" },
    { label: "Claims", count: count?.claimsCount || 0, image: "../images/claims.svg" },
    {label: "Broker/Carriers", count: count?.carrierCount || 0, image: "../images/broker.svg" },
    { label: "Historical Data", count: count?.historicalDataCount || 0, image: "../images/historical-data.svg"},
  ];

  useEffect(() => {
    getDocTypeWidget();
  }, []);

  useEffect(() => {
    if (selectedWidget) {
      widgetSelected(selectedWidget);
    }
  }, [selectedWidget, widgetSelected]);

  let onLoginError = (err: any) => {
    console.log(err);
  }

  const getDocTypeWidget = () => {
    var url = `api/dashboard/widget-doc-types?orgId=${saasOrgId}`;
    NetworkManager.sendJsonRequest(url, "", "", "GET", true, onDocTypeWidget, onLoginError);
  }
  
  const onDocTypeWidget = (dataObj: any) => {
  if (dataObj) {
    const restData = JSON.parse(dataObj);
    if (restData && !restData.errorMessage) {
      const dynamicWidgets = restData.docTypes?.map((doc: any) => ({
        label: `Document Type`,
        count: doc?.gridCount,
        image: "../images/processed.svg",
        InfoText: "Last 30 Days",
        docTypeName: doc.docTypeName,
        docTypeId: doc.docTypeId,
      }));

      setDynamicWidgets(dynamicWidgets);

      const combined = [...dynamicWidgets, ...staticWidgets];
      const storedWidget = localStorage.getItem("selectedWidget");

      if (storedWidget) {
        const parsed = JSON.parse(storedWidget);
        // Match it to ensure the widget still exists (may have been removed or changed)
        const matchedWidget = combined.find(
          (w) =>
            w.label === parsed.label &&
            (parsed.docTypeId ? w.docTypeId === parsed.docTypeId : true)
        );
        if (matchedWidget) {
          setSelectedWidget(parsed);
          return;
        }
      }

      // Fallback to default if no match
      if (combined.length > 0) {
        setSelectedWidget({
          label: combined[0].label,
          ...(combined[0].docTypeId ? { docTypeId: combined[0].docTypeId } : {}),
        });
      }
    } else {
      ToastManager.showToast(restData.errorMessage, "Error");
    }
  }
};

  const combinedWidgets = [...dynamicWidgets, ...staticWidgets];

  useEffect(() => {
  const savedWidget = localStorage.getItem("selectedWidget");
  if (savedWidget) {
    setSelectedWidget(JSON.parse(savedWidget));
  } else if (combinedWidgets.length > 0) {
    setSelectedWidget({
      label: combinedWidgets[0].label,
      ...(combinedWidgets[0].docTypeId ? { docTypeId: combinedWidgets[0].docTypeId } : {}),
    });
  }
}, [dynamicWidgets]);

const handleWidgetClick = (widget:any) => {
  const selected = {
    label: widget.label,
    ...(widget.docTypeId ? { docTypeId: widget.docTypeId } : {}),
  };
  setSelectedWidget(selected);
  localStorage.setItem("selectedWidget", JSON.stringify(selected));
};

  
  return (
    <div className="inspection-features">
      <div className="row g-3">
        {combinedWidgets.map((widget, index) => {
          const isActive = selectedWidget?.label === widget.label && 
                          (widget.docTypeId ? selectedWidget?.docTypeId === widget.docTypeId : true);
          const showAddButton = supportedAddButtons.includes(widget.label);

          return (
            <div className="col-sm-6 col-xl-3" key={index}>
              <div
                className={`card ${isActive ? "active" : ""}`}
                onClick={() => handleWidgetClick(widget)}
                style={{ cursor: "pointer", position: "relative" }}
              >
                {showAddButton && (
                  <button
                    className="product-pop-label"
                    onClick={(e) => {
                      e.stopPropagation();
                      onAddClick(widget.label);
                    }}
                  ><i className="fa-solid fa-plus small"></i></button>
                )}
              <div className="card-details">
                <div className="widget-icon">
                  <img src={widget.image} className="img-fluid" alt={widget.label} />
                </div>
                <div className="w-100">
                  <div className="history">
                    <div className="number">{widget.count}</div>
                    <div className={`subscribe text-end ${!widget.InfoText ? "d-none" : ""}`}>
                      {widget.InfoText}
                    </div>
                  </div>
                  <div className="label">{widget.label === "Document Type" ? `${widget.docTypeName}` : widget.label }</div>
                </div>
              </div>
            </div>
          </div>
          );
        })}
      </div>
    </div>
  );
};

export default DashboardWidget;